import { useState } from 'react'
import { AlertSimType } from '../../types/AlertTypes'
import { Card } from '@radix-ui/themes'
import { IconForbid2 } from '@tabler/icons-react'

interface IModalProps {
  setShowSimulateAlertModal: (show: boolean) => void
  simulateAlert: (alert: AlertSimType) => void
  platform: string
  caEnabled: boolean
}

function AlertSimulateModal(props: IModalProps) {
  const { setShowSimulateAlertModal, simulateAlert, platform, caEnabled } = props
  const [selectedAlert, setSelectedAlert] = useState<AlertSimType>(
    platform == 'IOS' ? AlertSimType.PEGASUS : AlertSimType.MALICIOUS_APK
  )
  return (
    <div
      className="bg-black bg-opacity-50 absolute top-0 left-0 w-full h-full z-50"
      onClick={() => setShowSimulateAlertModal(false)}
    >
      <div
        className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 max-w-[500px] bg-modalBackground rounded-lg p-6 max-h-[90%] overflow-y-auto flex flex-col gap-2 border dark:border-gray-600"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-medium">Simulate Alert</h2>
        <p className="text-sm">Simulate a critical alert on this device to test detection and response workflows</p>
        <hr className="my-2" />
        <div className="align-items-start gap-4 flex flex-col">
          <div>
            <p className="font-medium">Select Alert</p>
            {(() => {
              const alertTypes =
                platform == 'IOS'
                  ? [AlertSimType.PEGASUS, AlertSimType.PREDATOR, AlertSimType.PRIVILEGE_ESCALATION]
                  : [AlertSimType.MALICIOUS_APK, AlertSimType.BOOTLOAD_VALIDATION, AlertSimType.DEVICE_ROOTED]
              return alertTypes.map((alertType) => (
                <div key={alertType}>
                  <label className="inline-flex h-8 items-center">
                    <input
                      type="radio"
                      name="alertType"
                      value={alertType.toString()}
                      className="peer sr-only"
                      checked={selectedAlert === alertType}
                      onChange={() => setSelectedAlert(alertType)}
                    />
                    <span className="mr-2 h-4 w-4 rounded-full border border-gray-500 bg-white flex items-center justify-center peer-checked:border-mainPurple">
                      <span
                        className={`h-2 w-2 rounded-full bg-mainPurple hover:bg-tertiaryPurple active:active:bg-tertiaryPurple ${selectedAlert === alertType ? 'block' : 'hidden'}`}
                      ></span>
                    </span>
                    {alertType.toString()}
                  </label>
                </div>
              ))
            })()}
          </div>
          {caEnabled && (
            <Card size="2" className="p-0 m-0 bg-neutral-4 border-transparent" variant="ghost">
              <div className="flex flex-col gap-2 p-3 text-sm">
                <div className="flex gap-2 font-medium items-center">
                  <IconForbid2 size={20} />
                  <p>Conditional Access is Enabled</p>
                </div>
                <p className="text-neutral-11">
                  By simulating a critical alert, the member assigned to the device may be suspended from corporate
                  access
                </p>
              </div>
            </Card>
          )}
          <div className="flex justify-end">
            <button
              className="px-4 py-2 mr-2 bg-neutral-1 border border-neutral-5 rounded text-neutral-12 font-medium"
              onClick={() => setShowSimulateAlertModal(false)}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 bg-mainPurple hover:bg-tertiaryPurple active:active:bg-tertiaryPurple text-white rounded font-medium"
              onClick={() => {
                setShowSimulateAlertModal(false)
                simulateAlert(selectedAlert)
              }}
            >
              Simulate
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
export default AlertSimulateModal
